import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import Modal from '../base/Modal';
import { ButtonV2 } from '../base/ButtonV2';
import { postNotificationViewed } from '../../api';
const useStyles = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '500px'
  }
});
const Notification = ({
  notification
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleSubmit = async () => {
    setOpen(false);
    await postNotificationViewed(notification._id);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    className: classes.root,
    open: open,
    onClose: handleSubmit
  }, /*#__PURE__*/React.createElement("h2", null, notification.title), /*#__PURE__*/React.createElement("p", null, notification.message), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ButtonV2, {
    style: {
      float: 'right'
    },
    onClick: handleSubmit
  }, "Okay")));
};
Notification.propTypes = {
  notification: PropTypes.object
};
export default Notification;